import { action } from "../const";

let initialState = {
    notification: { title: "", options: {} },
    browserFocuse: true,
}

export default function notificationReducer(state = initialState, data) {

    switch (data.type) {

        case action.SEND_BROWSER_NOTIFICATION:
            return {
                ...state,
                notification: data.payload
            }

        case action.BROWSER_FOCUSE_STATUS:
            return {
                ...state,
                browserFocuse: data.payload
            }

        default:
            break;
    }
    return state;
}